const roles = {
  superadmin: {
    description: 'CDVI superadmin - Has access to all features and settings.',
  },
  customer_support: {
    description:
      'CDVI customer support - Has access to customer support features and settings.',
  },
  administration: {
    description: 'CDVI administration - Has access to ???.',
  },
  marketing: {
    description: 'CDVI marketing - Has access to ???.',
  },
  dealer_administrator: {
    description:
      'Dealer administrator - Has access to everything in the dealer.',
  },
  dealer_accounts_manager: {
    description:
      'Dealer accounts manager - Has access to dealer accounts management.',
  },
  account_administrator: {
    description:
      'Account administrator - Has access to everything in the account.',
  },
  account_site_manager: {
    description:
      'Account site manager - Has access to everything for a specific site.',
  },
  account_door_manager: {
    description:
      'Account door manager - Has access to door management features.',
  },
};

export default roles;
